import Axios from '../../api/_axios';
import { useAPIMethods } from '../../api';
import { useDialog } from '../dialog';

const BASIC_API_URL = process.env.REACT_APP_BASE_API_URL;

const useProvideAPI = () => {
  const dialogHandler = useDialog();

  const axios = new Axios({
    baseURL: BASIC_API_URL,
    timeout: 1800,
    recallOn: false,
    recallTimes: 3,
    dialogHandler,
    shouldReturnCode: true,
  });

  const api = useAPIMethods({ axios, dialogHandler });

  return Object.assign({}, api);
};

export default useProvideAPI;
